import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './store';
import type { Capability } from '@/features/auth/types';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export function useCurrentUser() {
  return useAppSelector((state) => state.auth.user);
}

export function useAuthInitialised() {
  return useAppSelector((state) => state.auth.initialised);
}

/**
 * Capability check for presentation only — deciding which nav items and
 * buttons to render. The server re-checks every request, so a tampered client
 * gains nothing but a broken screen.
 */
export function useCan(): (capability: Capability) => boolean {
  const capabilities = useAppSelector((state) => state.auth.capabilities);
  return (capability: Capability) => capabilities.includes(capability);
}
